import { TikTokSearchContainer } from "@/components/tiktok/TikTokSearchContainer";

export default function TikTokSearch() {
  return (
    <div className="container max-w-screen-2xl mx-auto p-4 pt-20 md:pt-8 lg:pt-12 space-y-6 md:space-y-8">
      <TikTokSearchContainer />
    </div>
  );
}